const PATH = 'fe.components.measure.observation_scores.scores_by_cycle_table';

const messages = {
  expandAll: {
    key: `${PATH}.expand_all`,
    defaultValue: 'Expand all'
  },
  collapseAll: {
    key: `${PATH}.collapse_all`,
    defaultValue: 'Collapse all'
  },
  cycle: {
    key: `${PATH}.cycle`,
    defaultValue: 'Cycle {{number}}'
  },
  cycleAbbreviated: {
    key: `${PATH}.cycle_abbreviated`,
    defaultValue: 'C{{number}}'
  },
  notScored: {
    key: `${PATH}.not_scored`,
    defaultValue: 'Not scored'
  },
  dimension: {
    key: `${PATH}.dimension`,
    defaultValue: 'Dimension'
  },
  rangesTitle: {
    key: `${PATH}.ranges_title`,
    defaultValue: 'Ranges'
  },
  scoresTitle: {
    key: `${PATH}.scores_title`,
    defaultValue: 'Scores'
  }
};

export default messages;
